@if (prescriptionFormList$ | async; as prescriptionFormList) {
  <div>
    <table>
      <thead>
        <tr>
          <th tuiTh colspan="5">Patient</th>
          <th tuiTh colspan="7">Prescription</th>
        </tr>
        <tr>
          <th tuiTh>Nom</th>
          <th tuiTh>Prénom</th>
          <th tuiTh>NIR</th>
          <th tuiTh>Téléphone</th>
          <th tuiTh>Adresse</th>
          <th tuiTh>Type</th>
          <th tuiTh>Date de validité</th>
          <th tuiTh>Date d'édition</th>
          <th tuiTh>Editer par</th>
          <th tuiTh>Pour le compte du Dr</th>
          <th tuiTh>Récapitulatif</th>
          <th tuiTh>Document</th>
        </tr>
      </thead>
      <tbody>
        @for (
          prescriptionForm of prescriptionFormList.list;
          track prescriptionForm.id
        ) {
          <app-prescription-form-row
            tuiTr
            [prescriptionForm]="prescriptionForm"
          />
        }
      </tbody>
    </table>
  </div>
  <tui-pagination
    [activePadding]="3"
    [index]="prescriptionFormList.currentPage - 1"
    [length]="prescriptionFormList.lastPage"
    (indexChange)="changementDePage($event)"
  />
} @else {
  <table>
    <thead>
      <tr>
        <th tuiTh colspan="5">Patient</th>
        <th tuiTh colspan="7">Prescription</th>
      </tr>
      <tr>
        <th tuiTh>Nom</th>
        <th tuiTh>Prénom</th>
        <th tuiTh>NIR</th>
        <th tuiTh>Téléphone</th>
        <th tuiTh>Adresse</th>
        <th tuiTh>Type</th>
        <th tuiTh>Date de validité</th>
        <th tuiTh>Date d'édition</th>
        <th tuiTh>Editer par</th>
        <th tuiTh>Pour le compte du Dr</th>
        <th tuiTh>Récapitulatif</th>
        <th tuiTh>Document</th>
      </tr>
    </thead>

    <tbody>
      <app-prescription-form-row
        tuiTr
        [prescriptionForm]="undefined"
        class="placeholder"
      />
      <app-prescription-form-row
        tuiTr
        [prescriptionForm]="undefined"
        class="placeholder"
      />
      <app-prescription-form-row
        tuiTr
        [prescriptionForm]="undefined"
        class="placeholder"
      />
      <app-prescription-form-row
        tuiTr
        [prescriptionForm]="undefined"
        class="placeholder"
      />
      <app-prescription-form-row
        tuiTr
        [prescriptionForm]="undefined"
        class="placeholder"
      />

      <app-prescription-form-row
        tuiTr
        [prescriptionForm]="undefined"
        class="placeholder"
      />
      <app-prescription-form-row
        tuiTr
        [prescriptionForm]="undefined"
        class="placeholder"
      />
      <app-prescription-form-row
        tuiTr
        [prescriptionForm]="undefined"
        class="placeholder"
      />
      <app-prescription-form-row
        tuiTr
        [prescriptionForm]="undefined"
        class="placeholder"
      />
      <app-prescription-form-row
        tuiTr
        [prescriptionForm]="undefined"
        class="placeholder"
      />

      <app-prescription-form-row
        tuiTr
        [prescriptionForm]="undefined"
        class="placeholder"
      />
      <app-prescription-form-row
        tuiTr
        [prescriptionForm]="undefined"
        class="placeholder"
      />
      <app-prescription-form-row
        tuiTr
        [prescriptionForm]="undefined"
        class="placeholder"
      />
      <app-prescription-form-row
        tuiTr
        [prescriptionForm]="undefined"
        class="placeholder"
      />
      <app-prescription-form-row
        tuiTr
        [prescriptionForm]="undefined"
        class="placeholder"
      />
    </tbody>
  </table>
}
